import { InputMask } from "@/components/forms";
import { Button, Callout, Heading, Icon, Text } from "@/components/ui";
import { Market } from "@/icons";
import { AddressSchemaType } from "@/types/forms";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import type { CityMismatch } from "./use-address-entry-geocoding";

/** First step of the map-backed flow: GPS or CEP, the two ways to seed a position without typing an address. */
export function AddressEntryStep({
  text,
  loading,
  errors,
  register,
  cityMismatch,
  onUseLocation,
}: {
  text: string;
  loading: boolean;
  errors: FieldErrors<AddressSchemaType>;
  register: UseFormRegister<AddressSchemaType>;
  cityMismatch: CityMismatch;
  onUseLocation: () => void;
}) {
  return (
    <>
      <Heading level={1} size="title" align="center" className="w-full">
        {text}
      </Heading>
      <div className="flex flex-col gap-4 items-center">
        <Button
          variant="outline"
          selected
          size="row"
          fullWidth
          onClick={onUseLocation}
          disabled={loading}
        >
          <Icon as={Market} size="xl" />
          <Text as="span" size="lg" weight="bold">
            Usar minha localização
          </Text>
        </Button>
        <Text size="lg">ou</Text>
        <div className="w-full">
          <InputMask
            name="postalCode"
            label="CEP"
            error={!!errors.postalCode}
            errorMsg="CEP inválido"
            registerAction={register}
            mask="_____-___"
            replacement={{ _: /\d/ }}
            placeholder="Insira seu CEP"
            disabled={loading}
            required={false}
          />
        </div>
        {cityMismatch.mismatch && (
          <Callout tone="warning" title="Fora da área de entrega" className="w-full">
            Esse endereço não está na região atendida pela loja
            {(cityMismatch.city || cityMismatch.state) && (
              <> ({[cityMismatch.city, cityMismatch.state].filter(Boolean).join(" - ")})</>
            )}
            . Use um CEP ou um ponto dentro da área de entrega.
          </Callout>
        )}
      </div>
    </>
  );
}
